import { gql } from '@apollo/client';

const USER = gql`
  query GetUser {
    currentUser {
      id
      firstName
      lastName
      shortName
      getHelpUrl
      role
      ventureCapital {
        name
        siteMode
      }
      navigationPermissions {
        isSiteModeDefault
        isSiteModeLite
        isLimitedPartner
        isGpOrPm
        isCompanyPageAccessible
      }
      deviceId
      belongsToPlatform
    }
  }
`;

const GET_LOGIN_META = gql`
  query GetLoginMeta($email: String!) {
    loginMeta(email: $email) {
      oidcLoginUrl,
      ssoLoginUrl,
      nonPlatformLoginExists
      platformLoginExists
    }
  }
`;

export { USER, GET_LOGIN_META };
